<mat-accordion>
  <mat-expansion-panel *ngIf="isImpersonating || isAdminUser" hideToggle [expanded]="transferType == 'sms'">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="sms-tools-titlepanel-div">
          Test Messaging
        </div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div>
      <app-send></app-send>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel hideToggle [expanded]="transferType == 'history'">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="sms-tools-titlepanel-div">
          {{isGlobal ? "Global " : ""}}Message Insights
        </div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div>
      <app-message-history [system]="isGlobal"></app-message-history>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel hideToggle [expanded]="transferType == 'history'">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="sms-tools-titlepanel-div">
          Traffic Analysis
        </div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div>
      <app-traffic-dashboard></app-traffic-dashboard>
    </div>
  </mat-expansion-panel>
</mat-accordion>
